import * as React from "react";
import "./Card.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from "../../i18n/custom.i18n";
import { LazyLoadImageCDN } from "./CDNImage";

import { OverlayContainer, PriceContainer } from "./CardStylings";
import { 
    AddinInfo, 
    AddinPublisher, 
    AddinVersion, 
    AddinDesc 
} from "./AddinStyles";
import { CardContact } from "../ContactTrigger/CardContact";
import { PageLink } from "../ContactTrigger/CardContactPublisher";
import i18next from "i18next";


let OverlayHeight = "auto";

export const AddinCard = (data: any) => {
    const { t, i18n } = useTranslation();
    const [OverlayDisplay, setOverlayDisplay] = React.useState("none");

    let name = data.name.replaceAll(" -", "-").replaceAll("- ", "-").replaceAll(" ", "-").replaceAll("/", "-").replaceAll("'", "-").replaceAll(".", "-").replaceAll("_", "-").replaceAll("(", "").replaceAll(")", "").replaceAll('#', '').replaceAll(',', '');
    var image = "";

    if (data.image){
        image = data.folder_name + "/" + data.image;
    }

    let DetailsURL = window.Paths.HOST_DETAILS;
    if (window.Settings.LOCAL_BUILD) {
        switch(window.Languages.language) {
            case "en":
                DetailsURL += window.Paths.DETAILS_URL + "addin=" + data["package_name"];
                break;

            default:
                DetailsURL += window.Paths.DETAILS_URL + "lang=" + window.Languages.language + "&" + "addin=" + data["package_name"];
                break;
        }
    } else {
        switch(window.Languages.language) {
            case "en":
                DetailsURL += "/addin/" + data["package_name"];
                break;
            
            default:
                DetailsURL += "/addin/" + window.Languages.language + "/" + data["package_name"];
                break;
        }
    }

    return (
        <div id={name} className="library-robot-container">
            <div
                className="library-robot"
                onMouseEnter={(e: React.MouseEvent) => {
                    if(OverlayDisplay == "none") {
                        let station_title = e.currentTarget.childNodes[0] as HTMLHeadingElement;
                        let station_image = e.currentTarget.childNodes[1] as HTMLDivElement;
                        let image_padding = 17;

                        OverlayHeight = (station_title.clientHeight + station_image.clientHeight + image_padding).toString();

                        setOverlayDisplay("flex");
                    }
                }}
                onMouseLeave = {(e: React.MouseEvent) => setOverlayDisplay("none")}
            >
                <h6 className="robot-title">{data.name}</h6>
                <div className="image-box-addin">
                    <LazyLoadImageCDN 
                        cdnPath={image != "" ? window.Paths.ROBODK_CDN + window.Paths.FOLDER_ADDINS_IMG_CDN + image : window.Paths.ADDIN_LIB_ASSETS_CDN + "np-icon.png"}
                        localPath={image != "" ? window.Paths.FOLDER_ADDINS_IMG + image : window.Paths.ADDIN_LIB_ASSETS + "np-icon.png"}
                        alt={data.name}
                        libAssetsPath={window.Paths.ADDIN_LIB_ASSETS}
                        classname={"img-addin"}
                    />
                </div>

                {/* <AddinInfo>
                    <AddinPublisher 
                        href={data.link["Homepage"]}
                        target={"_blank"}
                    >
                        {data.publisher}
                    </AddinPublisher>
                    <AddinVersion>{data.version}</AddinVersion>
                </AddinInfo> */}

                <AddinInfo>
                    <AddinPublisher 
                        href={data.link["Homepage"]}
                        target={"_blank"}
                    >
                        {data.publisher}
                    </AddinPublisher>
                    <AddinDesc>
                        {data.description}
                    </AddinDesc>
                </AddinInfo>
                {data.price != 'Free' && (
                    <PriceContainer>{window.format_currency(data.currency, data.price)}</PriceContainer>
                )}
            </div>

            <OverlayContainer 
                key={"overlay-" + data.name} 
                // height={OverlayHeight} 
                height="max"
                display={OverlayDisplay}
            >
                <div className="robot-links">
                    {window.Settings.open_in_rdk && data["form_num"] != 1 &&
                        <div 
                            onClick={(e) => window.get_lib(true, data.file, "addin")} 
                            role="button" 
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardOpenBtn')}</strong>
                        </div>
                    }
                    {
                        <a 
                            href={DetailsURL} 
                            //onClick={(e) => window.open(DetailsURL, "_blank")} 
                            target="_blank" 
                            type="button" 
                            role="button" 
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDetailsBtn')}</strong>
                        </a>
                    }
                    {data["form_num"] == 0 && (
                        <div
                            onClick={(e) => window.get_lib(false, data.file, "addin")} 
                            role="button" 
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDownloadBtn')}</strong>
                        </div>
                    )}

                    {data.price != 'Free' && window.Settings.enable_buy && (
                        <div
                            onClick={(e) => window.open(window.Paths.ROBODK_BUY + "?addin_name=" + encodeURI(data["name"]) + "&addin_code=" + data["package_name"] + "&addin_price=" + data.price, '_blank')} 
                            role="button" 
                            className="btn-robot-link center-block"
                            style={{backgroundColor:"#008a43"}}
                        >
                            <strong>{t('library-overlays.cardBuyBtn')}</strong>
                        </div>
                    )}

                    {data["form_num"] == 1 && (
                        <CardContact name={data["name"]} />
                    )}

                    {data["publisher"] != "RoboDK Inc." && data["link"]["homepage"] != "" && (
                        <PageLink 
                            link={data['link']['homepage'] + "?utm_source=robodk&utm_medium=library"}
                        />
                    )}
                </div>
            </OverlayContainer>
        </div>
    )
}
